(function () {
  'use strict';

  var WORKER_URL = 'https://shopify-draft-order-proxy.xxx3423zzz.workers.dev';

  // ── Cascade data: business type → subtypes ──────────────────────────────────
  var SUBTYPES = {
    'Asian': ['Chinese', 'Japanese / Sushi', 'Korean', 'Thai', 'Vietnamese', 'Indian', 'Filipino', 'Other Asian'],
    'Latin American': ['Mexican', 'Peruvian', 'Brazilian', 'Colombian', 'Other Latin'],
    'European': ['Italian', 'French', 'Greek', 'Spanish', 'Other European'],
    'American': ['American', 'Southern / Soul Food'],
    'Mediterranean': ['Mediterranean', 'Middle Eastern', 'Turkish'],
    'Seafood': ['Seafood'],
    'BBQ / Steakhouse': ['BBQ / Steakhouse'],
    'Pizza': ['Pizza'],
    'Fast Food / Quick Service': ['Fast Food / Quick Service'],
    'Café / Bakery': ['Café', 'Bakery'],
    'Catering': ['Catering'],
    'Bar / Lounge': ['Bar / Lounge'],
    'Other': ['Other'],
  };

  // ── Required field IDs per panel (panels 0 and 1) ──────────────────────────
  var REQUIRED_PANEL = {
    0: ['mem-restaurant-name', 'mem-business-type', 'mem-business-subtype', 'mem-restaurant-phone', 'mem-address1', 'mem-city', 'mem-province', 'mem-zip'],
    1: ['mem-first-name', 'mem-last-name', 'mem-email', 'mem-owner-phone', 'mem-manager-name', 'mem-manager-phone', 'mem-manager-email', 'mem-emergency-name', 'mem-emergency-title', 'mem-emergency-phone'],
  };

  // ── Helpers ─────────────────────────────────────────────────────────────────

  function val(id) {
    return (document.getElementById(id)?.value || '').trim();
  }

  // setField: sets a value and fires an input event so floating-label CSS triggers
  function setField(id, value) {
    var el = document.getElementById(id);
    if (!el || !value) return;
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // errorsDiv references — resolved inside DOMContentLoaded
  var errorsDiv = null;

  // showError: accepts trusted hardcoded HTML only (never raw server text)
  function showError(html) {
    if (!errorsDiv) return;
    errorsDiv.innerHTML = html;
    errorsDiv.removeAttribute('hidden');
  }

  // showErrorText: safe for untrusted/server-supplied messages
  function showErrorText(msg) {
    if (!errorsDiv) return;
    errorsDiv.textContent = msg;
    errorsDiv.removeAttribute('hidden');
  }

  function clearErrors() {
    if (!errorsDiv) return;
    errorsDiv.textContent = '';
    errorsDiv.setAttribute('hidden', '');
  }

  // ── Validation ───────────────────────────────────────────────────────────────

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Validate panels 0 and 1 (text/select fields)
  // Returns true if valid, false otherwise. Scrolls to first error.
  function validatePanel(tabIndex) {
    var ids = REQUIRED_PANEL[tabIndex];
    if (!ids) return true;

    var firstError = null;

    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var field = el.closest('.mem-field');
      var errEl = document.getElementById(id + '-err');
      var empty = !el.value.trim();

      // Special: email format check
      if (id === 'mem-email' && !empty) {
        empty = !EMAIL_RE.test(el.value.trim());
      }

      if (empty) {
        if (field) field.classList.add('mem-field--error');
        if (!firstError) firstError = field || el;
      } else {
        if (field) field.classList.remove('mem-field--error');
      }
    });

    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    return true;
  }

  // Validate panel 2 (checkboxes + disclaimer)
  // Returns true if valid.
  function validatePanel2() {
    var valid = true;

    // Ordering method: at least one checkbox checked
    var checked = document.querySelectorAll('#mem-ordering-method input:checked').length;
    var methodErr = document.getElementById('mem-ordering-method-err');
    if (checked === 0) {
      if (methodErr) methodErr.style.display = 'block';
      if (valid) {
        // Scroll to the first error
        var methodGroup = document.getElementById('mem-ordering-method');
        if (methodGroup) methodGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      valid = false;
    } else {
      if (methodErr) methodErr.style.display = '';
    }

    // Disclaimer checkbox
    var disclaimer = document.getElementById('mem-disclaimer-check');
    var disclaimerErr = document.getElementById('mem-disclaimer-err');
    if (!disclaimer || !disclaimer.checked) {
      if (disclaimerErr) disclaimerErr.style.display = 'block';
      if (valid && disclaimer) {
        disclaimer.closest('.mem-disclaimer')
          ? disclaimer.closest('.mem-disclaimer').scrollIntoView({ behavior: 'smooth', block: 'center' })
          : disclaimer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      valid = false;
    } else {
      if (disclaimerErr) disclaimerErr.style.display = '';
    }

    return valid;
  }

  // ── Main init ────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('aigo-membership-form');
    if (!form) return;

    errorsDiv = document.getElementById('mem-errors');

    // ── State ────────────────────────────────────────────────────────────────
    var currentTab = 0;
    var maxReachedTab = 0;

    // ── Tab / panel element refs ──────────────────────────────────────────────
    function getTab(i) { return document.getElementById('mem-tab-' + i); }
    function getPanel(i) { return document.getElementById('mem-panel-' + i); }

    // The two progress bars sit between tab 0↔1 and tab 1↔2 in the DOM.
    // Query them once — they are the .mem-tab__bar elements (not the first one
    // which has mem-tab__bar--active already applied in HTML).
    var tabBars = Array.from(document.querySelectorAll('.mem-tab__bar'));
    // tabBars[0] = bar between tab 0 and tab 1
    // tabBars[1] = bar between tab 1 and tab 2

    // ── Bar sync helper ───────────────────────────────────────────────────────
    // Bar i sits between tab i and tab i+1.
    // Activate it once the user has reached tab i+1 (maxReachedTab > i).
    function syncBars(tabBars, maxReachedTab) {
      tabBars.forEach(function (bar, i) {
        if (i < maxReachedTab) {
          bar.classList.add('mem-tab__bar--active');
        } else {
          bar.classList.remove('mem-tab__bar--active');
        }
      });
    }

    // ── Navigate forward ──────────────────────────────────────────────────────
    function goToNext() {
      // 1. Validate
      var valid = currentTab === 2 ? validatePanel2() : validatePanel(currentTab);
      if (!valid) return;

      // 2. Mark current tab done
      var curTabEl = getTab(currentTab);
      if (curTabEl) {
        curTabEl.classList.remove('mem-tab--active');
        curTabEl.classList.add('mem-tab--done');
        curTabEl.setAttribute('aria-selected', 'false');
        var numEl = curTabEl.querySelector('.mem-tab__num');
        if (numEl) numEl.textContent = '✓';
      }

      // 3. Hide current panel
      var curPanel = getPanel(currentTab);
      if (curPanel) curPanel.classList.remove('mem-panel--active');

      // 5. Advance index
      currentTab += 1;
      maxReachedTab = Math.max(maxReachedTab, currentTab);

      // 6. Sync all bars to match maxReachedTab
      syncBars(tabBars, maxReachedTab);

      // 7. Enable and activate next tab header
      var nextTabEl = getTab(currentTab);
      if (nextTabEl) {
        nextTabEl.removeAttribute('disabled');
        nextTabEl.setAttribute('aria-selected', 'true');
        nextTabEl.classList.add('mem-tab--active');
      }

      // 8. Show next panel
      var nextPanel = getPanel(currentTab);
      if (nextPanel) nextPanel.classList.add('mem-panel--active');

      // 9. Scroll to top of wizard
      var page = document.querySelector('.membership-page');
      if (page) page.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ── Navigate backward ─────────────────────────────────────────────────────
    function goToBack() {
      if (currentTab === 0) return;

      // Hide current panel and deactivate current tab
      var curPanel = getPanel(currentTab);
      if (curPanel) curPanel.classList.remove('mem-panel--active');

      var curTabEl = getTab(currentTab);
      if (curTabEl) {
        curTabEl.classList.remove('mem-tab--active');
        curTabEl.setAttribute('aria-selected', 'false');
      }

      // Decrement
      currentTab -= 1;

      // Show previous panel and activate previous tab
      var prevPanel = getPanel(currentTab);
      if (prevPanel) prevPanel.classList.add('mem-panel--active');

      var prevTabEl = getTab(currentTab);
      if (prevTabEl) {
        // Restore numeric label if the tab was marked done when going forward
        prevTabEl.classList.remove('mem-tab--done');
        var numEl = prevTabEl.querySelector('.mem-tab__num');
        if (numEl) numEl.textContent = String(currentTab + 1);
        prevTabEl.classList.add('mem-tab--active');
        prevTabEl.setAttribute('aria-selected', 'true');
      }

      // Sync bars to reflect current navigation state
      syncBars(tabBars, maxReachedTab);

      // Scroll to top
      var page = document.querySelector('.membership-page');
      if (page) page.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ── Navigate to a specific tab (header click) ─────────────────────────────
    function goToTab(targetIndex) {
      if (targetIndex === currentTab) return;        // clicking current — no-op
      if (targetIndex > maxReachedTab) return;       // future tab — not unlocked yet

      // Hide current
      var curPanel = getPanel(currentTab);
      if (curPanel) curPanel.classList.remove('mem-panel--active');

      var curTabEl = getTab(currentTab);
      if (curTabEl) {
        curTabEl.classList.remove('mem-tab--active');
        curTabEl.setAttribute('aria-selected', 'false');
      }

      currentTab = targetIndex;

      // Show target
      var targetPanel = getPanel(currentTab);
      if (targetPanel) targetPanel.classList.add('mem-panel--active');

      var targetTabEl = getTab(currentTab);
      if (targetTabEl) {
        // Remove done styling when re-entering a completed tab
        targetTabEl.classList.remove('mem-tab--done');
        // Restore numeric label
        var numEl = targetTabEl.querySelector('.mem-tab__num');
        if (numEl) numEl.textContent = String(currentTab + 1);
        targetTabEl.classList.add('mem-tab--active');
        targetTabEl.setAttribute('aria-selected', 'true');
      }

      // Sync all bars to match maxReachedTab (fixes forward-jump deactivating wrong bar)
      syncBars(tabBars, maxReachedTab);

      var page = document.querySelector('.membership-page');
      if (page) page.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ── Event: Next buttons ───────────────────────────────────────────────────
    form.addEventListener('click', function (e) {
      var nextBtn = e.target.closest('[data-next]');
      if (nextBtn) {
        goToNext();
        return;
      }
      var backBtn = e.target.closest('[data-back]');
      if (backBtn) {
        goToBack();
        return;
      }
    });

    // ── Event: Tab header clicks ──────────────────────────────────────────────
    var tabsContainer = document.querySelector('.mem-tabs');
    if (tabsContainer) {
      tabsContainer.addEventListener('click', function (e) {
        var tabBtn = e.target.closest('.mem-tab');
        if (!tabBtn) return;
        var idx = parseInt(tabBtn.dataset.tab, 10);
        if (!isNaN(idx)) goToTab(idx);
      });
    }

    // ── Business type → subtype cascade ──────────────────────────────────────
    var typeSelect = document.getElementById('mem-business-type');
    var subtypeSelect = document.getElementById('mem-business-subtype');

    if (typeSelect && subtypeSelect) {
      typeSelect.addEventListener('change', function () {
        var chosen = typeSelect.value;

        // Manage floating label on type select
        if (chosen) {
          typeSelect.removeAttribute('data-empty');
        } else {
          typeSelect.setAttribute('data-empty', 'true');
        }

        // Reset subtype options to just the placeholder
        subtypeSelect.options.length = 1; // keep index 0 = "Select subcategory"

        if (chosen && SUBTYPES[chosen]) {
          var opts = SUBTYPES[chosen];
          opts.forEach(function (label) {
            var o = document.createElement('option');
            o.value = label;
            o.textContent = label;
            subtypeSelect.appendChild(o);
          });
          subtypeSelect.removeAttribute('disabled');
          subtypeSelect.removeAttribute('data-empty');

          // Auto-select if only one option
          if (opts.length === 1) {
            subtypeSelect.value = opts[0];
          }
        } else {
          // No type chosen — disable subtype
          subtypeSelect.setAttribute('disabled', '');
          subtypeSelect.setAttribute('data-empty', 'true');
          subtypeSelect.value = '';
        }
      });

      subtypeSelect.addEventListener('change', function () {
        if (subtypeSelect.value) {
          subtypeSelect.removeAttribute('data-empty');
        } else {
          subtypeSelect.setAttribute('data-empty', 'true');
        }
      });
    }

    // ── Pre-fill for logged-in non-members ────────────────────────────────────
    if (form.dataset.prefillEmail) {
      setField('mem-first-name', form.dataset.prefillFirst);
      setField('mem-last-name', form.dataset.prefillLast);
      setField('mem-email', form.dataset.prefillEmail);
      // Strip +1 prefix from prefilled phone so only 10 digits go in the input
      setField('mem-owner-phone', (form.dataset.prefillPhone || '').replace(/^\+1/, ''));
    }

    // ── Owner phone — real-time taken check on blur ───────────────────────────
    var ownerPhoneInput = document.getElementById('mem-owner-phone');
    var ownerPhoneWarn  = document.getElementById('mem-owner-phone-warn');
    if (ownerPhoneInput && ownerPhoneWarn) {
      ownerPhoneInput.addEventListener('blur', function () {
        var phone = '+1' + ownerPhoneInput.value.trim();
        if (!ownerPhoneInput.value.trim()) { ownerPhoneWarn.setAttribute('hidden', ''); return; }
        fetch(WORKER_URL + '/?action=check-phone&phone=' + encodeURIComponent(phone))
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.taken) {
              ownerPhoneWarn.removeAttribute('hidden');
            } else {
              ownerPhoneWarn.setAttribute('hidden', '');
            }
          })
          .catch(function () { ownerPhoneWarn.setAttribute('hidden', ''); });
      });
    }

    // ── Same-as helpers ───────────────────────────────────────────────────────
    function lockFields(ids) {
      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.setAttribute('readonly', '');
      });
    }
    function unlockFields(ids) {
      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.removeAttribute('readonly');
      });
    }

    var MGR_FIELDS = ['mem-manager-name', 'mem-manager-phone', 'mem-manager-email'];
    var EC_FIELDS  = ['mem-emergency-name', 'mem-emergency-title', 'mem-emergency-phone'];

    // ── Manager "Same as Owner" ───────────────────────────────────────────────
    var mgrSameAsOwner = document.getElementById('mem-manager-same-as-owner');
    if (mgrSameAsOwner) {
      mgrSameAsOwner.addEventListener('change', function () {
        if (mgrSameAsOwner.checked) {
          setField('mem-manager-name', (val('mem-first-name') + ' ' + val('mem-last-name')).trim());
          setField('mem-manager-phone', val('mem-owner-phone'));
          setField('mem-manager-email', val('mem-email'));
          lockFields(MGR_FIELDS);
        } else {
          MGR_FIELDS.forEach(function (id) { setField(id, ''); });
          unlockFields(MGR_FIELDS);
        }
      });
    }

    // ── Emergency Contact "Same as" (mutually exclusive) ──────────────────────
    var ecSameAsOwner = document.getElementById('mem-ec-same-as-owner');
    var ecSameAsMgr   = document.getElementById('mem-ec-same-as-manager');

    function fillEmergencyFromOwner() {
      setField('mem-emergency-name',  (val('mem-first-name') + ' ' + val('mem-last-name')).trim());
      setField('mem-emergency-title', 'Owner');
      setField('mem-emergency-phone', val('mem-owner-phone'));
      lockFields(EC_FIELDS);
    }
    function fillEmergencyFromManager() {
      setField('mem-emergency-name',  val('mem-manager-name'));
      setField('mem-emergency-title', 'Manager');
      setField('mem-emergency-phone', val('mem-manager-phone'));
      lockFields(EC_FIELDS);
    }
    function clearEmergency() {
      EC_FIELDS.forEach(function (id) { setField(id, ''); });
      unlockFields(EC_FIELDS);
    }

    if (ecSameAsOwner) {
      ecSameAsOwner.addEventListener('change', function () {
        if (ecSameAsOwner.checked) {
          if (ecSameAsMgr) ecSameAsMgr.checked = false;
          fillEmergencyFromOwner();
        } else {
          clearEmergency();
        }
      });
    }
    if (ecSameAsMgr) {
      ecSameAsMgr.addEventListener('change', function () {
        if (ecSameAsMgr.checked) {
          if (ecSameAsOwner) ecSameAsOwner.checked = false;
          fillEmergencyFromManager();
        } else {
          clearEmergency();
        }
      });
    }

    // ── Form submission ───────────────────────────────────────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Re-validate all panels (guards against navigating back and clearing a required field)
      if (!validatePanel(0) || !validatePanel(1) || !validatePanel2()) return;

      // Clear previous submit error
      clearErrors();

      var submitBtn = form.querySelector('.mem-submit');
      var originalHTML = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting\u2026';
      }

      // Collect payload
      var payload = {
        first_name:        val('mem-first-name'),
        last_name:         val('mem-last-name'),
        email:             val('mem-email'),
        phone:             '+1' + val('mem-owner-phone'),
        restaurant_name:   val('mem-restaurant-name'),
        restaurant_phone:  val('mem-restaurant-phone'),
        business_type:     val('mem-business-type'),
        // val() handles disabled selects correctly — .value is accessible even when disabled
        business_subtype:  val('mem-business-subtype'),
        restaurant_hours:  val('mem-restaurant-hours'),
        website:           val('mem-website'),
        address: {
          address1: val('mem-address1'),
          city:     val('mem-city'),
          province: val('mem-province'),
          zip:      val('mem-zip'),
        },
        delivery_door:      val('mem-delivery-door'),
        manager_name:       val('mem-manager-name'),
        manager_phone:      val('mem-manager-phone'),
        manager_email:      val('mem-manager-email'),
        emergency_name:     val('mem-emergency-name'),
        emergency_title:    val('mem-emergency-title'),
        emergency_phone:    val('mem-emergency-phone'),
        ordering_method:    Array.from(document.querySelectorAll('#mem-ordering-method input:checked')).map(function (cb) { return cb.value; }),
        accepts_marketing:  document.getElementById('mem-marketing-check')?.checked ?? false,
      };

      // Logged-in non-members have data-customer-id set on the form; guests do not.
      var customerId = form.dataset.customerId;
      var action = customerId ? 'activate-membership' : 'signup';
      if (customerId) {
        payload.customer_id = Number(customerId);
      }

      fetch(WORKER_URL + '/?action=' + action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      .then(function (res) {
        return res.json().then(function (data) { return { status: res.status, data: data }; });
      })
      .then(function (r) {
        if (r.data.success) {
          if (submitBtn) submitBtn.textContent = 'Activating\u2026';
          setTimeout(function () { window.location.href = '/pages/membership-confirmation'; }, 1000);
          return;
        }
        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHTML;
        }
        // Server-supplied text — use textContent path (XSS-safe)
        showErrorText(r.data.message || 'Something went wrong. Please try again.');
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHTML;
        }
        showErrorText('Network error. Please check your connection and try again.');
      });
    });
  });

})();
